export default __webpack_public_path__ + "static/muscle-c08da014d0ae60f27e48b26075dcb27d.png";